<script>
  export let question;
  export let answerMap;
  export let numQuestion;

  import { onMount } from "svelte";

  let showWarning = false;

  onMount(() => {
    if (
      (question.inverted && answerMap[numQuestion] >= 3) ||
      (!question.inverted && answerMap[numQuestion] < 3)
    ) {
      showWarning = question.advice !== "";
    }
  });
</script>

<style>
  div.advice {
    background-color: var(--covid-warning-box);
    color: white;
    padding: 20px;
    border-radius: 10px;
    margin-bottom: 20px;
    -webkit-box-shadow: 0px 7px 9px -4px rgba(0, 0, 0, 0.57);
    -moz-box-shadow: 0px 7px 9px -4px rgba(0, 0, 0, 0.57);
    box-shadow: 0px 7px 9px -4px rgba(0, 0, 0, 0.57);
    display: flex;
  }

  div.advice div.img {
    width: 20%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  div.advice div.img img {
    height: 25px;
  }

  div.warningText {
    width: 80%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: var(--covid-warning-text);
  }

  div.arrow-up {
    width: 0;
    height: 0;
    margin-left: 25px;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    border-bottom: 12px solid var(--covid-warning-box);
  }

  div.arrow-up:not(:first-child) {
    margin-top: -15px;
  }

  /* Mobile phones */

  @media only screen and (max-width: 768px) {
    div.advice div.img {
      width: auto;
    }

    div.warningText {
      width: auto;
      text-align: center;
    }

    div.arrow-up {
      margin-top: 5px;
    }
  }
</style>

{#if showWarning}
  <div class="arrow-up" />
  <div class="advice">
    <div class="img">
      <img src="/images/alert.svg" alt="Warning icon" />
    </div>
    <div class="warningText">{question.advice}</div>
  </div>
{/if}
